export default __webpack_public_path__ + "static/media/6.5076f3f1.jpg";